import Input from 'components/Input';
import Select from 'components/Select';
import React, { useState } from 'react';
import { Button, Modal } from "react-bootstrap";


function AddEarningCodeModal({
    open,
    onClose
}) {
    const [show, setShow] = useState(false);

    return (
        <Modal className='add-workplace-modal' show={open} onHide={onClose} centered>
            <div className="modal-header border-0 pb-0 d-flex justify-content-between align-items-center">
                <h4 classNam="sub-title text-black mb-0">Add Earning Code</h4>
                <button
                    type="button"
                    className="close bg-transparent border-0"
                    onClick={onClose}
                >
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <Modal.Body className='pt-0'>
                <div>
                    <div>
                        <h2 className='sub-title workplace-information-title mb-0'>General Information</h2>
                    </div>
                    <form>
                        <div className='row mt-4'>
                            <div className='col-12'>
                                <label>Name</label>
                                <Input
                                    fullWidth
                                    variant='flat'
                                    placeholder='Enter Name'
                                />
                            </div>
                            <div className='col-12 mt-4'>
                                <label>Earning Type</label>
                                <Select
                                    fullWidth
                                    placeholder='Select Type'
                                    options={[]}
                                />
                            </div>
                        </div>
                    </form>
                </div>
            </Modal.Body>
            <Modal.Footer className='border-0 justify-content-start mb-5'>
                <Button className='button-orange'>
                    Add Earning Code
                </Button>
            </Modal.Footer>
        </Modal>
    );
}


export default AddEarningCodeModal;
